import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./index.scss";
import RealisationService from "../../../services/realisation/realisation.service";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const realisationService = new RealisationService();

const SectionCards = () => {
  const [blogs, setBlogs] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);
  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  const navigate = useNavigate();
  const { t } = useTranslation();

  function getImageURL(candidatureId) {
    return `${apiUrl}blogs/${candidatureId}/image`;
  }

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const data = await realisationService.getAllActiveRealisation();
        setBlogs(data?.data || []);
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setBlogs([]); // Set empty array on error to prevent crashes
      }
    };
    fetchBlogs();
  }, []);

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const truncateTitle = (title, maxLength = 50) => {
    if (!title) return "";
    return title.length > maxLength
      ? title.substring(0, maxLength) + "..."
      : title;
  };

  const handleVoirPlus = () => {
    setVisibleCount((prev) => prev + 6);
  };

  return (
    <section className="section-cards">
      <Container>
        <Row className="justify-content-center">
          {blogs.slice(0, visibleCount).map((blog) => (
            <Col
              key={blog._id}
              md={4}
              sm={6}
              className="mb-5 d-flex justify-content-center">
              <Card className="custom-card">
                <Card.Img
                  variant="top"
                  src={getImageURL(blog._id)}
                  className="card-img"
                />
                <Card.Body>
                  <Card.Title 
                    title={blog.title}
                    className="blog-title"
                  >
                    {truncateTitle(blog.title, 50)}
                  </Card.Title>
                  <Card.Text className="blog-description">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: truncateText(blog?.description, 300),
                      }}
                    />
                  </Card.Text>
                  <Button
                    variant="outline-primary"
                    onClick={() => navigate(`/blogDetails/${blog?._id}`)}
                    className="btn-read">
                    {t("sectionCards.readMore")}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {visibleCount < blogs.length && (
          <div className="text-center mt-4">
            <Button className="btn-more" onClick={handleVoirPlus}>
              {t("sectionCards.viewMore")}
            </Button>
          </div>
        )}
      </Container>
    </section>
  );
};

export default SectionCards;
